export const Read = 1;
export const Update = 2;
export const UpdateAndDelete = 3;
